<mat-form-field [className]="props.style" [appearance]="props.appearance">
  <mat-label id="label" [ngClass]="getStylesClasses('label')"
    >{{ props?.label }} {{ props['required'] ? '*' : '' }}</mat-label
  >
  <input
    matInput
    type="text"
    [formControl]="selectFormControl"
    [formlyAttributes]="field"
    [ngModel]="selectFormControl.value"
    hmtDefaultDecimalPlacesCommaDirective />
  <mat-error *ngIf="selectFormControl.errors?.['required']">{{ field.validation?.messages?.['required'] }}</mat-error>
</mat-form-field>
